
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.12 16.523a1.554 1.554 0 01-2.24 0L4.437 9.828c-.95-.987-.25-2.632 1.12-2.632h12.886c1.37 0 2.07 1.645 1.12 2.632l-6.443 6.695z","fill":"#282E3E"}})])
          )
        }
      }
    